import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "./actionTypes";
import * as StoreTypes from "../DataTypes/storeTypes";
import * as Actions from "./actions";
import * as AccountModel from "../../Common/accountModel";
import * as ClientActions from "./clientActions";

function updateIsUserLoggedIn(isLoggedIn: boolean): ActionGenerics.IParamAction<ActionTypes.Actions, boolean> {
    return { type: ActionTypes.Actions.UpdateIsUserLoggedIn, parameter: isLoggedIn };
}

function updateLoggedInClient(clientId: number): ActionGenerics.IParamAction<ActionTypes.Actions, number> {
    return { type: ActionTypes.Actions.UpdateLoggedInClient, parameter: clientId };
}

export function onLoggedIn(data: AccountModel.IAccountModel) {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(updateIsUserLoggedIn(true));

        dispatch(updateLoggedInClient(data.clientId));

        dispatch(ClientActions.selectClient(data.clientId));

        dispatch(Actions.moveNext());
    };
}
